<template>
  <div>
    <div class="">
      <b-row
        class="container-border"
        v-for="(item, index) in groupList"
        :key="index"
      >
        <b-col>
          <div class="d-flex align-items-end">
            <BarProgress :data="item" />
            <div class="my-2 ml-3">
              <b-dropdown
                size="lg"
                right
                variant="link"
                toggle-class="text-decoration-none"
                class="dropdown-unknow"
                no-caret
              >
                <template #button-content>
                  <font-awesome-icon class="my-auto" icon="ellipsis-v" />
                </template>
                <b-dropdown-item @click="$emit('handleCreateIntent', item)"
                  >Create Intent</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </b-col>
        <b-col class="right-line">
          <GroupText
            :dataList="item.word"
            :isShowAll="isShowAll"
            v-on:setShowAllGroupText="setShowAllGroupText"
          />
        </b-col>
      </b-row>
    </div>
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import BarProgress from "@/views/pages/chat-analysis/components/BarProgress";
import GroupText from "@/views/pages/chat-analysis/components/GroupText";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  components: {
    BarProgress,
    GroupText,
    ModalLoading,
  },
  props: {
    groupList: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      isShowAll: false,
      groupId: "",
      confirmDelete: {
        header: "Are you sure to delete this reply ?",
        text: "text",
        subText: "subText",
        button: {
          true: {
            class: ["btn-danger"],
            msg: "DELETE",
          },
          false: {
            class: ["btn-secondary"],
            msg: "CANCEL",
          },
        },
      },

      imgModals: null,
      msgModals: null,
      modalAlertShow: false,
      modalData: [],
      isSuccess: false,
    };
  },
  methods: {
    openDeleteModal(groupId, textSample) {
      this.groupId = groupId;
      this.confirmDelete = {
        header: `Are you sure to delete "${textSample}" group text?`,
        text: "",
        subText: "",
        button: {
          true: {
            class: ["btn-danger"],
            msg: "DELETE",
          },
          false: {
            class: ["btn-secondary"],
            msg: "CANCEL",
          },
        },
      };
      this.$refs.deleteConfirmModal.show();
    },
    onConfirmDelete: function(value) {
      if (value) {
        this.$refs.modalLoading.show();
        this.axios
          .delete(
            `${this.$baseUrl}/api/suggestkeyword/deleteGroup/${this.groupId}`
          )
          .then((data) => {
            this.$refs.modalLoading.hide();
            this.modalAlertShow = true;
            if (data.result == 1) {
              this.imgModals = "/img/icon-check-green.png";
              this.msgModals = data.message;
              this.isSuccess = true;
            } else {
              this.imgModals = "/img/icon-unsuccess.png";
              this.msgModals = data.detail[0];
              this.isSuccess = false;
            }
          });
      }
    },
    setShowAllGroupText() {
      this.isShowAll = !this.isShowAll;
    },
  },
};
</script>

<style lang="scss" scoped>
.f-size-18 {
  font-size: 18px;
}

.right-line {
  border-left: 1px solid #bebebe;
}

.container-border:last-child > .right-line > .grouptext-container {
  border-bottom: none;
}
</style>
